import { utils } from '@hh/global.js'

/* Country Selector - Desktop */
class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.open = false
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector('hh-button-wrapper > button'),
      panel: this.querySelector('[country-list-panel]'),
    }

    this.elements.button.addEventListener(
      'keyup',
      this.onTriggerKeyUp.bind(this)
    )
    document.body.addEventListener(
      'click',
      this.toggleSelector.bind(this)
    )
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    )
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false')
    this.elements.panel.setAttribute('hidden', true)
    this.elements.button.classList.remove('active')

    this.elements.button.focus({ focusVisible: true })
    this.open = false
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    this.hidePanel()
    this.elements.button.focus()
  }

  onTriggerKeyUp(e) {
    if ( e.type === 'keyup' && e.code.toUpperCase() !== 'ENTER' &&
      e.code.toUpperCase() !== 'ARROWDOWN') {
        return true
    }

    this.openSelector()
  }

  onItemClick(event) {
    event.preventDefault()
    const form = this.querySelector('form')
    this.elements.input.value = event.currentTarget.dataset.value
    if (form) form.submit()
  }

  openSelector() {
    const isExpanded =
      this.elements.button.getAttribute('aria-expanded') === 'true'
    this.elements.panel.toggleAttribute('hidden')
    this.elements.button.setAttribute('aria-expanded', (!isExpanded).toString())
    this.elements.button.classList.toggle('active', !isExpanded)
    this.open = !this.open
    utils.trapFocus(this.elements.panel)
  }

  toggleSelector(event) {
    if (event.target !== this.elements.panel && event.target !== this.elements.button) {
      if (this.open) {
        this.hidePanel()
      }
    } else if (event.target === this.elements.button) {
      if (!this.open) {
        this.openSelector()
      } else {
        this.hidePanel()
      }
    }
  }
}

customElements.define('localization-form', LocalizationForm)
